export class EmailsObject {
    constructor(emails) {
        this.emails = emails;
    }

    getEmails() {
        return this.emails;
    }
}